(function () {
  window.theme = window.theme || {};

  function getCompose() {
    return document.querySelector('[data-cart-drawer-gift-compose]');
  }

  function getGiftCheckbox() {
    const compose = getCompose();
    return compose ? compose.querySelector('[data-cart-drawer-gift-checkbox]') : null;
  }

  function composeNoteFromDom() {
    if (window.theme.getComposedDrawerCartNote) {
      return window.theme.getComposedDrawerCartNote();
    }
    const compose = getCompose();
    if (!compose) return '';
    const line = (compose.dataset.giftOrderLine || '').trim();
    const cb = getGiftCheckbox();
    const ta = document.getElementById('CartDrawerGiftNote');
    const custom = ta ? String(ta.value || '').trim() : '';
    const intentOn =
      window.theme.isGiftCheckboxIntentPersisted &&
      window.theme.isGiftCheckboxIntentPersisted();
    if ((cb && cb.checked) || intentOn) {
      return line + (custom ? '\n\n' + custom : '');
    }
    return custom;
  }

  function pushDrawerGiftCartNote(note) {
    const hidden = document.getElementById('CartDrawerCartNoteField');
    if (hidden) hidden.value = note == null ? '' : String(note);
    if (window.theme.setCartDrawerGiftNoteBackup) {
      window.theme.setCartDrawerGiftNoteBackup(note == null ? '' : String(note));
    }
    if (!window.theme.routes || !window.theme.routes.cart_update_url) {
      return Promise.resolve();
    }
    return fetch(window.theme.routes.cart_update_url, {
      method: 'POST',
      body: JSON.stringify({ note: note == null ? '' : String(note) }),
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }).then(async (res) => {
      if (res.ok) {
        try {
          const data = await res.json();
          if (window.theme.updateDrawerGiftUIFromCart) {
            window.theme.updateDrawerGiftUIFromCart(data);
          }
        } catch (e) {
          /* ignore */
        }
      }
      return res;
    });
  }

  window.theme.pushDrawerGiftCartNote = pushDrawerGiftCartNote;

  function setDrawerGiftNotePanelOpen(open) {
    const compose = getCompose();
    if (!compose) return;
    const panel = compose.querySelector('[data-cart-drawer-gift-note-panel]');
    if (!panel) return;

    compose.classList.toggle('is-gift-note-open', !!open);
    if (open) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }

    document.body.dispatchEvent(
      new CustomEvent('cart-drawer-gift-sheet', {
        bubbles: true,
        composed: true,
        detail: { open: !!open },
      })
    );

    if (open) {
      window.requestAnimationFrame(() => {
        const ta = document.getElementById('CartDrawerGiftNote');
        if (ta) ta.focus();
      });
    }
  }

  window.theme.setDrawerGiftNotePanelOpen = setDrawerGiftNotePanelOpen;

  function onGiftMessageCheckboxChange(open) {
    if (window.theme.persistGiftCheckboxIntent) {
      window.theme.persistGiftCheckboxIntent(open);
    }
    if (window.theme.persistGiftNotePanelOpen) {
      window.theme.persistGiftNotePanelOpen(open);
    }
    if (!open) {
      setDrawerGiftNotePanelOpen(false);
      const ta = document.getElementById('CartDrawerGiftNote');
      if (ta) ta.value = '';
      pushDrawerGiftCartNote('');
      document.body.dispatchEvent(
        new CustomEvent('cart-drawer-gift-note-state', {
          bubbles: true,
          composed: true,
          detail: { hasNote: false },
        })
      );
      return;
    }
    setDrawerGiftNotePanelOpen(true);
    pushDrawerGiftCartNote(composeNoteFromDom());
  }

  window.theme.onGiftMessageCheckboxChange = onGiftMessageCheckboxChange;

  function syncPanelFromIntent() {
    const cb = getGiftCheckbox();
    const intent =
      window.theme.isGiftCheckboxIntentPersisted &&
      window.theme.isGiftCheckboxIntentPersisted();
    const panelOpen =
      window.theme.isGiftNotePanelOpenPersisted &&
      window.theme.isGiftNotePanelOpenPersisted();
    if (cb && intent && !cb.checked) cb.checked = true;
    if (panelOpen && (intent || (cb && cb.checked))) {
      setDrawerGiftNotePanelOpen(true);
    }
  }

  window.theme.syncDrawerGiftNotePanelFromIntent = syncPanelFromIntent;

  document.addEventListener(
    'change',
    (e) => {
      const cb = e.target.closest('[data-cart-drawer-gift-checkbox]');
      if (!cb) return;
      onGiftMessageCheckboxChange(!!cb.checked);
    },
    true
  );

  document.addEventListener(
    'change',
    (e) => {
      if (e.target.id !== 'CartDrawerGiftNote') return;
      pushDrawerGiftCartNote(composeNoteFromDom());
    },
    true
  );

  document.addEventListener('click', (e) => {
    const saveBtn = e.target.closest('[data-cart-drawer-gift-save-note]');
    if (saveBtn) {
      e.preventDefault();
      const ta = document.getElementById('CartDrawerGiftNote');
      if (ta) pushDrawerGiftCartNote(composeNoteFromDom());
      if (window.theme.persistGiftNotePanelOpen) {
        window.theme.persistGiftNotePanelOpen(false);
      }
      setDrawerGiftNotePanelOpen(false);
      const hasNote = !!(ta && String(ta.value || '').trim());
      document.body.dispatchEvent(
        new CustomEvent('cart-drawer-gift-note-state', {
          bubbles: true,
          composed: true,
          detail: { hasNote },
        })
      );
      return;
    }
    const noNoteBtn = e.target.closest('[data-cart-drawer-gift-no-note]');
    if (noNoteBtn) {
      e.preventDefault();
      const ta = document.getElementById('CartDrawerGiftNote');
      if (ta) ta.value = '';
      const compose = getCompose();
      const line = compose ? (compose.dataset.giftOrderLine || '').trim() : '';
      pushDrawerGiftCartNote(line);
      if (window.theme.persistGiftNotePanelOpen) {
        window.theme.persistGiftNotePanelOpen(false);
      }
      setDrawerGiftNotePanelOpen(false);
      document.body.dispatchEvent(
        new CustomEvent('cart-drawer-gift-note-state', {
          bubbles: true,
          composed: true,
          detail: { hasNote: false },
        })
      );
    }
  });

  document.addEventListener('DOMContentLoaded', syncPanelFromIntent);
  document.addEventListener('shapes:cart:update', () => {
    window.queueMicrotask(syncPanelFromIntent);
  });
  document.addEventListener('cart-is-open', () => {
    window.queueMicrotask(syncPanelFromIntent);
  });
})();
